import * as EmailValidator from "email-validator";
import axios from "axios";
import qs from "qs";
import { useGlobals } from "@/main";

export function isPhoneValid(input) {
  if (input === null) return false;

  input = input.replace(/\s+/g, "");
  const phoneRegExp = /^[+]?[0-9]{9,}$/;
  return phoneRegExp.test(input);
}

export function isEmailValid(input) {
  // teoretycznie też powinna byc weryfikacja po stronie serwera - jak ktoś wyłączy JavaScript w przeglądarce?
  if (input == null) return false;
  return EmailValidator.validate(input);
}

export function isPasswordValid(input) {
  //Hasło musi mieć minumum 8 znaków (bez spacji)
  if (input === null) return false;

  let passwordRegExp = new RegExp(/^[^ ]{8,}$/);
  return passwordRegExp.test(input);
}

export function round2dec(num) {
  return Math.round(num * 100) / 100;
}

export async function makeRequest(
  data,
  requestType = "POST",
  url = useGlobals().hostname
) {
  let requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify(data),
    url: url,
  };
  let dataRequestResponse = null;
  if (requestType === "POST") dataRequestResponse = await axios(requestOptions);
  if (requestType === "GET") dataRequestResponse = await axios.get(data);

  return dataRequestResponse;
}

export function scrollToTop() {
  document.body.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
}
